export const DRAG_HANDLE_ICON = 'drag-horizontal-2';

export const DRAG_HANDLE_PLACEMENT = {
    // Sits inside the row it drags.
    INLINE: 'inline',
    // Sits in the margin to the left of the row, appearing when the row is hovered.
    OUTSIDE: 'outside',
};

export const DRAG_HANDLE_PLACEMENTS = Object.values(DRAG_HANDLE_PLACEMENT);
